import { render, staticRenderFns } from "./table-regional-nucleus-health.vue?vue&type=template&id=421ed534&scoped=true&"
import script from "./table-regional-nucleus-health.vue?vue&type=script&lang=js&"
export * from "./table-regional-nucleus-health.vue?vue&type=script&lang=js&"
import style0 from "./table-regional-nucleus-health.vue?vue&type=style&index=0&id=421ed534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ed534",
  null
  
)

export default component.exports